import { getExportPdf } from '@/services/api/contactNetwork';
import { appendQueryString } from '@/utils/';
import { mapActions } from 'vuex';

export default {
    name: 'ExportContacts',
    props: {
        contactsTotal: {
            type: Number,
            default: 0
        },
        isMobile: [Boolean, Object]
    },
    data() {
        return {
            periodFilters: [
                { label: 'Todos os contatos', value: '' },
                { label: 'Adquiridos nos últimos 15 dias', value: '15' },
                { label: 'Adquiridos nos últimos 30 dias', value: '30' },
                { label: 'Adquiridos nos últimos 45 dias', value: '45' }
            ],
            periodFilter: '',
            loadingExport: false
        };
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        updateFilter(option) {
            this.periodFilter = option;
            this.$emit('updateFilter', this.getPeriodFilter());
        },
        async exportContacts() {
            this.loadingExport = true;
            try {
                const daysAgo = appendQueryString('', this.getPeriodFilter());
                const { data } = await getExportPdf(daysAgo);
                this.donwloadContacts(data, 'Contatos adquiridos.csv');
            } catch (error) {
                console.error(error);
                this.loadingExport = false;
            } finally {
                this.loadingExport = false;
                this.showNotification({ text: 'Contatos exportados com sucesso.', type: 'success' });
            }
        },
        donwloadContacts(dataPdf, filename) {
            const blob = new Blob([dataPdf], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            URL.revokeObjectURL(link.href);
        },
        getPeriodFilter() {
            if (this.periodFilter.value && parseInt(this.periodFilter.value) !== 0) {
                return `days_ago=${this.periodFilter.value}`;
            }
            return '';
        }
    }
};
